import { memo, useEffect, useState } from "react";
import { cn } from "@/modern/utils";

interface MarketingPagePreviewProps {
  href: string;
  title: string;
}

export const MarketingPagePreview = memo(function MarketingPagePreview({
  href,
  title,
}: MarketingPagePreviewProps) {
  const [previewLoaded, setPreviewLoaded] = useState(false);

  useEffect(() => {
    setPreviewLoaded(false);
  }, [href]);

  return (
    <div className="flex aspect-[16/10] w-full flex-col overflow-hidden rounded-md border border-border/60 bg-muted/40">
      <div className="flex shrink-0 items-center gap-2 border-b border-border/50 bg-muted/50 px-2 py-1.5">
        <div className="flex shrink-0 items-center gap-1">
          <span className="size-1.5 rounded-full bg-muted-foreground/30" />
          <span className="size-1.5 rounded-full bg-muted-foreground/30" />
          <span className="size-1.5 rounded-full bg-muted-foreground/30" />
        </div>
        <p className="min-w-0 truncate font-mono text-[10px] text-muted-foreground" title={href}>
          {href}
        </p>
      </div>
      <div className="relative min-h-0 flex-1">
        {!previewLoaded && (
          <div
            className="absolute inset-0 z-[1] flex items-center justify-center bg-muted/40"
            aria-hidden
          >
            <p className="text-[10px] font-medium text-muted-foreground">Loading preview…</p>
          </div>
        )}
        <iframe
          src={href}
          title={`Preview: ${title}`}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          onLoad={() => setPreviewLoaded(true)}
          className={cn(
            "pointer-events-none absolute inset-0 h-full w-full border-0 bg-background",
            "transition-opacity duration-300",
            previewLoaded ? "opacity-100" : "opacity-0",
          )}
        />
      </div>
    </div>
  );
});
